import { Reveal, MaskLines } from "./motion";
import { GALLERIES } from "../../lib/assets";
import { GlassCard, DeviceMock } from "./Glass";

const steps = [
  { n: "01", t: "Ingresa tu FSC ID", d: "En el checkout de la web escribes tu FSC ID para iniciar el pago." },
  { n: "02", t: "Confirma en la app", d: "Recibes la solicitud en Aurexis y la confirmas con un toque." },
  { n: "03", t: "Listo y verificable", d: "El comercio recibe la confirmación al instante y tú conservas el control." },
];

export const Flow = () => {
  return (
    <section
      id="experiencia"
      data-testid="flow-section"
      className="min-h-screen bg-canvas px-6 pb-24 pt-28 md:px-12"
    >
      <div className="mx-auto max-w-6xl">
        <div className="max-w-3xl">
          <Reveal>
            <span className="font-accent text-xs uppercase tracking-[0.25em] text-gold">
              La experiencia
            </span>
          </Reveal>
          <h2 className="mt-5 font-display text-4xl font-normal leading-none tracking-tight text-ink md:text-6xl">
            <MaskLines lines={["De tu web a Aurexis,", "sin fricción."]} />
          </h2>
          <Reveal delay={0.1}>
            <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-ink-soft md:text-lg">
              Comprar es tan fácil como ingresar tu FSC ID en la página y
              confirmar el pago desde la app. El comercio recibe la
              confirmación y tú conservas el control de cada operación.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-5 lg:grid-cols-12">
          <GlassCard testId="flow-device" className="p-8 md:p-10 lg:col-span-6">
            <DeviceMock
              src={GALLERIES.checkout[0].src}
              alt={GALLERIES.checkout[0].alt}
              className="min-h-[420px]"
              imgClassName="max-h-[520px]"
            />
          </GlassCard>

          <div className="grid grid-cols-1 gap-5 lg:col-span-6">
            {steps.map((s, i) => (
              <GlassCard
                key={s.n}
                testId={`flow-step-${s.n}`}
                delay={0.05 * i}
                className="flex items-start gap-5 p-7 md:p-8"
              >
                <span className="font-accent text-3xl font-light text-gold">
                  {s.n}
                </span>
                <div>
                  <h3 className="font-display text-2xl text-ink">{s.t}</h3>
                  <p className="mt-1 font-body text-sm leading-relaxed text-ink-soft">
                    {s.d}
                  </p>
                </div>
              </GlassCard>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
